export {
  storageCreateFolder as fetchCreateFolder,
  storageDelete as fetchDeleteFileOrFolder,
  storageGetTree as fetchFolderTree,
  storageList as fetchFileList, // 注释掉原来的导入，使用上面的 mock 版本
  storageMove as fetchMoveFileOrFolder,
  storageUpdate as fetchUpdateFileOrFolder,
} from '@/app/services/infer/sdk.gen';
export { favorsBatchFavorite } from '@/app/services/tools';
export { creationsDetail } from '@/app/services/vidu';
